module.exports = __webpack_public_path__ + "static/img/logo-Viewmed.cc59984.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-Viewmed.svg
// module id = N29b
// module chunks = 0 97